export const titleSorter = (a, b) => {
  const titleA = a.frontmatter?.title
  const titleB = b.frontmatter?.title
  if (titleA && titleB) {
    return titleA.localeCompare(titleB)
  }
  return 0
}
